const SUBMIT_FORM = '[Generic] Submit form';

export const All = {
    SUBMIT_FORM
};
